/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Link_Dialog_TitleInputs */

const vi_kiotviet_link_dialog_title = /** @type {(inputs: Kiotviet_Link_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nối sản phẩm`)
};

/**

* @param {Kiotviet_Link_Dialog_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_link_dialog_title = /** @type {((inputs?: Kiotviet_Link_Dialog_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Link_Dialog_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_link_dialog_title(inputs)
});